import { createSlice } from '@reduxjs/toolkit';

const accordionSlice = createSlice({
  name: 'accordion',
  initialState: {
    payinOpenIndex: 0,
    payoutOpenIndex: 0
  },
  reducers: {
    setAccordionState(state, action) {
      const { payinOpenIndex, payoutOpenIndex } = action.payload;
      if (payinOpenIndex !== undefined && payinOpenIndex !== state.payinOpenIndex) {
        state.payinOpenIndex = payinOpenIndex;
      }

      if (payoutOpenIndex !== undefined && payoutOpenIndex !== state.payoutOpenIndex) {
        state.payoutOpenIndex = payoutOpenIndex;
      }
    }
  }
});

export const { setAccordionState } = accordionSlice.actions;
export default accordionSlice.reducer;